import Alert, { AlertType } from "../../../components/Alert";
import "./../resellers.scss";
import AddPackage from "../../../components/packages/AddPackage";

const BillableResellerPackages = ({ selectedPackages = [], title, availablePackages, setSelectedPackages, setCanSubmit }) => {

	return (
		<div>
			{(!title.startsWith("Edit")) &&
				<>
					<p>These are the packages that the Reseller will have access to when provisioning new customers or passing on access to their retailers.</p>
					<Alert type={AlertType.Warning}>It is crucial to input the correct values below, as they directly determine the billing of the Reseller.</Alert>
				</>
			}
			<AddPackage
				selectedPackages={selectedPackages}
				availablePackages={availablePackages}
				setSelectedPackages={setSelectedPackages}
				isValid={setCanSubmit}
			/>
		</div>
	);
};

export default BillableResellerPackages;